import axios from "axios";
import { BASEURL } from "../constant/Url";

const apiConfig = {
  baseURL: BASEURL,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
};
export const api = axios.create(apiConfig);
